export const sampleUser = {
     title:"Mr.",
     firstName:"Stephen",
     lastName:"Okechukwu",
     email:"stephen2022@gmail.com",
     phone:"+2348099012343",
     address:"1A, Walter Carrington Avenue, Victoria Island, Lagos.",
     huid:1003405,
     age:33,
     sex:"Male",
     avatar:"https://st3.depositphotos.com/2783505/32838/i/600/depositphotos_328381898-stock-photo-passport-photo-of-african-american.jpg",
     vitals:{
          height:180,
          weight:90,
          bp:"120/80",
          blood_group: "O+",
          genotype:"AA"
     },
     visits:[
          {
               id:1,
               date:"17/05/2022", 
               time:"12:05PM", 
               doctor:"Dr. Mirabel Nwosu", 
               specialization:"Cardiology", 
               visitType:"OutPatient", 
               summary:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi beatae temporibus corporis nihil, iusto, veritatis doloribus eum ipsa, expedita sint quos praesentium quo aperiam. Fugit officia perferendis dolorum voluptas aliquid."
          },
          {
               id:2,
               date:"23/06/2022", 
               time:"03:00PM", 
               doctor:"Dr. Vivian Ukomadu", 
               specialization:"General Practice", 
               visitType:"Walk In", 
               summary:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi beatae temporibus corporis nihil, iusto, veritatis doloribus eum ipsa, expedita sint quos praesentium quo aperiam. Fugit officia perferendis dolorum voluptas aliquid."
          },
          {
               id:3,
               date:"19/08/2022", 
               time:"11.05AM", 
               doctor:"Dr. Joy Ekwueme", 
               specialization:"Optometry", 
               visitType:"Walk In", 
               summary:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi beatae temporibus corporis nihil, iusto, veritatis doloribus eum ipsa, expedita sint quos praesentium quo aperiam. Fugit officia perferendis dolorum voluptas aliquid."
          },
          {
               id:4,
               date:"23/09/2022", 
               time:"08.05PM", 
               doctor:"Dr. Enaholo Odia", 
               specialization:"Family Medicine", 
               visitType:"OutPatient", 
               summary:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi beatae temporibus corporis nihil, iusto, veritatis doloribus eum ipsa, expedita sint quos praesentium quo aperiam. Fugit officia perferendis dolorum voluptas aliquid."
          },
          {
               id:5,
               date:"10/11/2022", 
               time:"09.00AM", 
               doctor:"Dr. Ayodeji Odufuwa", 
               specialization:"General Practice", 
               visitType:"OutPatient", 
               summary:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi beatae temporibus corporis nihil, iusto, veritatis doloribus eum ipsa, expedita sint quos praesentium quo aperiam. Fugit officia perferendis dolorum voluptas aliquid."
          }
     ],
     diagnostics:{
          lab:[
               {
                    serial:1,
                    invoice:"DL001",
                    service:"FULL BLOOD COUNT",
                    date:"23/10/2022",
                    status:"Finalized",
                    action:"Download"
               },
               {
                    serial:2,
                    invoice:"DL002",
                    service:"HBA1C (HS16)",
                    date:"24/10/2022",
                    status:"Pending",
                    action:"None"
               },
               {
                    serial:3,
                    invoice:"DL003",
                    service:"LIPIDS TEST",
                    date:"25/10/2022",
                    status:"Finalized",
                    action:"Download"
               },
               {
                    serial:4,
                    invoice:"DL004",
                    service:"ESR",
                    date:"24/10/2022",
                    status:"Pending",
                    action:"None"
               },
               {
                    serial:5,
                    invoice:"DL005",
                    service:"URINE TEST",
                    date:"28/10/2022",
                    status:"Finalized",
                    action:"Download"
               },
          ],
          radio:[
               {
                    serial:1,
                    invoice:"DR001",
                    service:"48HRS HOLTER TEST",
                    date:"23/10/2022",
                    status:"Finalized",
                    action:"Download"
               },
               {
                    serial:2,
                    invoice:"DR002",
                    service:"ADULT ECHOCARDIOGRAM",
                    date:"24/10/2022",
                    status:"Pending",
                    action:"None"
               },
               {
                    serial:3,
                    invoice:"DR003",
                    service:"ABDOMINAL ULTRASOUND",
                    date:"25/10/2022",
                    status:"Finalized",
                    action:"Download"
               },

          ]
     },
     appointments:[],
     payments:[]
}



export const faqs = [
     {
          question:"OPD Management",
          answer:"An organized OPD for handling large number of patients to be attended by multiple Doctors in an OPD. The complete cycle of an effective OPD from Registration, Patient History, Patient Diagnosis, and Prescription etc. is stored and managed effectively."
     },
     {
          question:"IPD Management",
          answer:"Complete Inpatient Management Module that manages all your hospital inpatient functionality from Patient registration to the billing with a complete tracking of Patient records."
     },
     {
          question:"OT Management",
          answer:"Operation theater module caters to the scheduling of operation theaters, surgery team, patient tracking, operation theater consumable management, accounting and Operation theater roster and notes with Death and Birth certificates."
     },
     {
          question:"Pathology Software",
          answer:"Pathology Lab Management facilitates definition of laboratory tests supporting fully configurable laboratory tests reports that are ordered in outpatient or Inpatient instantaneously."
     },
     {
          question:"TPA Management",
          answer:"Aarogya comes with an integrated TPA module offering seamless insurance management to process the bills settlement of the patients covered under insurance."
     }
]


export const termsOfService = "Welcome to Evercare Hospital Lekki Portal. This portal belongs to Evercare Hospital Lekki Limited ('Evercare'), an integrated healthcare delivery platform operating in Nigeria. Evercare helps communities thrive by improving healthcare and leveraging technology and integration to increase the quality of care. Evercare is building a foundation of continuous quality improvement and standardized care to improve clinical outcomes and patient safety.The Terms and Conditions ('Terms') contained herein on this webpage, shall govern your access to and use of this website, including all pages, images, illustrations, designs, photographs, video clips, text, icons, designs written information, and other materials that appear on this website (together the Website). Please read these Terms carefully. By accessing the Website and/or using the online services, you agree to be bound by the following Terms. If you do not accept any of these Terms, you must immediately discontinue your access to this Website and/or use of the online services.By using our Website and/or online services, you accept these Terms in full."